import Vue from 'vue'
import Vuex from 'vuex'
import router from './router';

Vue.use(Vuex)

export default new Vuex.Store({
	state: {
		token: ''
	},
	mutations: {
		SET_TOKEN(state, token) {
			state.token = token
		},
	},
	actions: {
		setToken({
			commit
		}, token) {
			return new Promise(resolve => {
				if (token) {
					commit('SET_TOKEN', token)
					resolve()
				}
			})
		},
		// 删除token
		resetToken({
			commit
		}) {
			commit('SET_TOKEN', '')
			router.replace('/login')
		}
	}
})
